export const BUTTON_ALLOWED_TYPES = ['primary', 'secondary', 'danger', 'outlined', 'filled'];
export const BUTTON_FILLED_TYPES = ['primary', 'secondary', 'danger', 'filled'];
export const BUTTON_DEFAULT_TYPE = 'primary';
export const BUTTON_BASE_CLASSNAME = 'ww-btn';
export const BUTTON_FILLED = 'filled';
export const BUTTON_OUTLINED = 'outlined';